export default __webpack_public_path__ + "static/media/red.a11833f3.svg";